import React, { useEffect, useMemo, useState } from 'react'
import Styles from "./styles.module.scss";
import Combodropdown from '../../../components/autocomplete'
import TagLabel from '../../../components/TagLabel';
import * as CONSTANTS from '../../../utils/CONSTANTS';
import { Error } from "@progress/kendo-react-labels";
import FromHead from '../../../components/headings/FromHead';
import FormHead from '../../../components/headings/FromHead';
import Button from '../../../components/button';
import { useForm } from 'react-hook-form';
import { UpdateProviderDomain } from "./services"
import NotificationAlert from '../../../components/notification';
import PlacesAutocomplete, {
  geocodeByAddress,
} from 'react-places-autocomplete';
import { Icon } from "@iconify/react";

const { v4: uuidv4 } = require('uuid');

export type CompanyDetailsForm = {
    domain: any;
    skills: any;
    jobRole: any;
}
 
interface Props {
    back?: any;
    clickHandler?: any;
    defaultValues?: any;
    isExistingCustomer?: boolean;
    providerDomains?: any;
    domainsList?: any;
    customerId?: any;
    getProviderDomainsList?: any;
    jobRolesList: any;
    skillsList: any;
}


const CompanyDetails: React.FC<Props> = ({
    back,
    clickHandler,
    defaultValues,
    providerDomains,
    domainsList,
    customerId,
    getProviderDomainsList,
    jobRolesList,
    skillsList,
    isExistingCustomer
}) => {

    const formOptions = { defaultValues:useMemo(() => {
        return defaultValues;
      }, [defaultValues]) };
    
    
      const {
        handleSubmit,
        setValue,
      } = useForm<CompanyDetailsForm>(formOptions);
    
    const [addedSkills, setAddedSkills] = useState<{ name: string, id: number, other: boolean }[]>([])
    const [addedDomains, setAddedDomains] = useState<{ name: string, id: number, other: boolean }[]>([])
    const [skillOthers, setSkillOthers] = useState<boolean>(false)
    const getAddedEngineering = () => [...CONSTANTS.Engineering, ...addedEngineering.filter(item => item.other)]
    const getDefaultJobRole = (item: { name: string, id: number }) => addedEngineering ? !!addedEngineering.filter(id => id.id === item.id).length : false
    const [engineeringOthers, setEngineeringOthers] = useState<boolean>(false)
    const [errors, setErros] = useState<{ engineering?: string, domains?: string, skills?: string}>({engineering:'', domains:'', skills:''})
    const [addedEngineering, setAddedEngineering] = useState<{ name: string, id: number, other: boolean }[]>([])
    const getAddedDomains = () => domainsList && domainsList.length > 0 && [...domainsList, ...addedDomains.filter(item => item.other)]
    const getDefaultDomains = (item: { name: string, id: number }) => addedDomains ? !!addedDomains.filter(id => id.id === item.id).length : false
    const [domainOthers, setDomainOthers] = useState<boolean>(false)
    const getAddedSkills = () => [...CONSTANTS.Skills, ...addedSkills.filter(item => item.other)]
    const getDefaultSkills = (item: { name: string, id: number | null }) => addedSkills ? !!addedSkills.filter(id => id.id === item.id).length : false
    const [message, setMessage] = useState<string>('')
    const [notification, setNotification] = useState<boolean>(false)
    const [address, setAddress] = useState('')
    const [locationArray, setLocationArray] = useState<{id:string, name:string}[]>([])
  
  useEffect(() => {
    
    if (defaultValues.services) {

      const techStack = defaultValues.services ? defaultValues.services.map((item: any) => {    
        return ({
          name: item.name, id: item.id, 
          other: CONSTANTS.Engineering.filter(skill => skill.id === item.id).length === 0
        })
      }) : []
      setAddedEngineering(techStack)
    }
    
    if (defaultValues.domains) {
      const domains = defaultValues.domains ? defaultValues.domains.map((item: any) => {
        return ({
          name: item.name, id: item.id,
          other: CONSTANTS.domains.filter(domain => domain.id === item.id).length === 0
        })
      }) : []
      setAddedDomains(domains)
    }

    if (defaultValues.skills) {
      const skills = defaultValues.skills ? defaultValues.skills.map((item: any) => {
        return ({
          name: item.name, id: item.id, other: CONSTANTS.Skills.filter(skills => skills.id === item.id).length === 0
        })
      }) : []
      setAddedSkills(skills)
    }
  }, [defaultValues])
  
    const engineeringChange = (e: any, engineering: { name: string, id: number }) => {
     
        delete errors.engineering
        setErros({ ...errors })
    
        let updatedEngineering: { name: string, id: number, other: boolean }
          = { ...engineering, other: e === 'addValue' }
    
        if (engineering !== null) {
          if ((e.value) || e === 'addValue') {
            addedEngineering.push(updatedEngineering)
            delete errors.engineering
            setErros({ ...errors })
            if (engineering.name === "Others") {
              setEngineeringOthers(true)
            }
          }
          else {
            const index = addedEngineering.findIndex(item => item.id === engineering.id);;
            if (index > -1) {
              addedEngineering.splice(index, 1);
            }
            if (engineering.name === "Others") {
              setEngineeringOthers(false)
            }
    
          }
          setAddedEngineering([...addedEngineering])
          setErros({ ...errors })
        }
        setValue('jobRole',addedEngineering)
    }
     
    const domainChange = (e: any, domain: any) => {
 
      delete errors.domains
      setErros({ ...errors })
    
      let updatedDomain: { name: string, id: number, other: boolean }
        = { ...domain, other: e === 'addValue' }
 
      if (domain !== null) {
        if ((e.value) || e === 'addValue') {
          addedDomains.push(updatedDomain)
          delete errors.domains
          setErros({ ...errors })
          if (domain.name === "Others") {
            setDomainOthers(true)
          }
        }else {
          const index = addedDomains.findIndex(item => item.id === domain.id);;
          if (index > -1) {
            addedDomains.splice(index, 1);
          }
          if (domain.name === "Others") {
            setDomainOthers(false)
          }
        }
        setAddedDomains([...addedDomains])
        setErros({ ...errors })
      }
      setValue('domain',addedDomains)
    }

  const skillChange = (e: any, skill: { name: string, id: number }) => {
        errors.skills = ''
        setErros({ ...errors })
        
        let updatedSkill: { name: string, id: number, other: boolean }
        = { ...skill, other: e === 'addValue' }
        
        if (skill !== null) {
          if (e.value || e === 'addValue') {
            addedSkills.push(updatedSkill)
            setErros({ ...errors })
            if (skill.name === "Others") {
              setSkillOthers(true)
            }
          }
          else {
            const index = addedSkills.findIndex(item => item.id === skill.id);
            if (index > -1) {
              addedSkills.splice(index, 1);
            }
            if (skill.name === "Others") {
              setSkillOthers(false)
            }
          }
        }
      setAddedSkills([...addedSkills])
      }

  const onSubmit = (data: any) => {
    
    const skillWithoutOthers = addedSkills.filter((item) => item.name !== 'Others' && item.name !== '')
 
    const domainWithoutOthers = addedDomains.filter((item) => item.name !== 'Others')
    
    const engineeringWithoutOthers = addedEngineering.filter((item) => item.name !== 'Others' && item.name !== '')
      
    const services = engineeringWithoutOthers.map((item) => {
      return (
        {
          id: item.id,
          name: item.name
        }
      )
    })

    const domain = domainWithoutOthers.map((item) => {
      return (
        {
          id: item.id,
          name: item.name
        }
      )
    })
    
    const skills = skillWithoutOthers.map((item) => {
      return (
        {
          id: item.id,
          name: item.name
        }
      )
    })
    
    let value = {
      services: services,
      domain: domain,
      skills: skills,
      googleLocations: locationArray, 
      customerStatus: 2
    }   
    if (value.skills && value.skills.length < 1) {
      errors.skills = "Field is required"      
      setErros({...errors})
    }
    if (value.services && value.services.length < 1) {
      errors.engineering = "Field is required"      
      setErros({...errors})
    }
    if (value.domain && value.domain.length < 1) {
      errors.domains = "Field is required"      
      setErros({...errors})
    }
    else if (value.skills && value.skills.length > 0 && value.services && value.services.length > 0 && value.domain && value.domain.length > 0) {
      if ((value.skills && value.skills.length) < 3 || (value.skills && value.skills.length > 10)) {
        errors.skills = "Min 3 skills and max 10 skills allowed"      
        setErros({ ...errors })
      }
      if ((value.services && value.services.length) < 3 || (value.services && value.services.length > 10)) {
        errors.engineering = "Min 3 services and max 10 services allowed"      
        setErros({ ...errors })
      }
      if ((value.domain && value.domain.length) < 3 || (value.domain && value.domain.length > 10)) {
        errors.domains = "Min 3 domain and max 10 domain allowed"      
        setErros({ ...errors })
      }
      else if((value.skills && value.skills.length) >= 3 && (value.skills && value.skills.length <= 10) && (value.services && value.services.length) >= 3 && (value.services && value.services.length <= 10) && (value.domain && value.domain.length) >= 3 && (value.domain && value.domain.length <= 10))
      clickHandler(value)
    }    
    }

  const onBlurCheck = (event: any) => {
     
    if(event.id){
      domainChange("addValue",event)
    }else{  
      let data = {
      "domain": event.name,
      "customerId": customerId
      }
      let domainList = [...providerDomains, ...domainsList]
    
      let domainCheck =  domainList.filter((item: any) => {
        return( item.name === event.name )
      })    
      if(domainCheck.length === 0 && event.name !== ' '){
        UpdateProviderDomain(data).then((response: any) => {
          if(response && response.status === 1){
            let value = {name: event.name, id: response.data[0].domain_id}
            domainChange("addValue", value)
            getProviderDomainsList()
          }
        })
      }else{ 
        displayNotification("Domain already exist!")
      }
    }
  }

  const displayNotification = (message: any) => {
    setMessage(message)
    setNotification(true)
    setTimeout(() => {
      setNotification(false)
    }, 5000)
  }

  const onClose = () => {
    setNotification(false)
  }

  const backButton = (event: any) => {
    if(event.detail === 1){  // mouse click on a button
      back()
    }
  }

  const handleSelect = async (value: any) => {

    const results = await geocodeByAddress(value);
    let data = {
      "id": uuidv4(),
      "name": results[0].formatted_address
    }    
    setLocationArray([...locationArray, data])
    setAddress('')
  }

  const removeLocation = (item: any) => {
    const index = locationArray.findIndex(findItem => findItem.id === item.id); 
    locationArray.splice(index, 1);
    setLocationArray([...locationArray])
  }

  return (
      <form className={Styles.comnpanyForm} onSubmit={(e : any) => { e.preventDefault()}}>
          <FromHead>Identify the services your firm offers*</FromHead>  
          <h6>Select min 3 to max 10 services</h6>
        <div className={Styles.tagLabelWrap}>
              {getAddedEngineering().map((item, key) => <TagLabel label={item.name}
                key={key}
                value={item.id}
                checked={getDefaultJobRole(item)}
                handleChange={(e: any) => engineeringChange(e, item)} />)}

              {engineeringOthers && <div className={Styles.tagDropdown}>
                <Combodropdown
                  placeholder="Please search your skill"
                  data={jobRolesList}
                  name='name'
                  id='id'
                  handleChange={(value: { name: string, id: number }) => engineeringChange("addValue", value)}
                />
              </div>}
              <Error>{errors.engineering}</Error>
          </div>  
          <FormHead>Identify your focused domains*</FormHead>
          <h6>Select min 3 to max 10 domains</h6>
          <div className={Styles.tagLabelWrap}>
              {domainsList && domainsList.length > 0 && getAddedDomains().map((item:any, key: number) => <TagLabel label={item.name}
                key={key}
                value={item.id}
                checked={getDefaultDomains(item)}
                handleChange={(e: any) => domainChange(e, item)} />)}

              {domainOthers && <div className={Styles.tagDropdown}>
                <div className="form-group">
                  <Combodropdown
                    placeholder="Please search your domain"
                    data={providerDomains}
                    name='name'
                    id='id'
                    handleChange={onBlurCheck}
                  />
                </div>
              </div>}
              <Error>{errors.domains}</Error>
          </div>    
          <FromHead>Identify your technology capability areas*</FromHead>
          <h6>Select min 3 to max 10 skills</h6>
        {/* <p>Please add (at least one or max of three of) your Core skills, years of experience and the competency of each skill</p> */}
        <div  className="form-group mb-40">
        {getAddedSkills().map((skill, key) => <TagLabel label={skill.name}
                key={key}
                value={skill.id}
                checked={getDefaultSkills(skill)}
                handleChange={(e: any) => skillChange(e, skill)} />)}

              {skillOthers && <div className={Styles.tagDropdown}>
                <Combodropdown
                  placeholder="Please search your skill"
                  data={skillsList}
                  name='name'
                  id='id'
                  handleChange={(value: { name: string, id: number }) => skillChange("addValue", value)}
                />
        </div>}
        <Error>{errors.skills}</Error>
          </div>
          <FromHead>Locations</FromHead>
          <div className={Styles.tagListGroup}>
             { locationArray && locationArray.map((item) => {
               return (
                <div className={Styles.tagListItem}>
                  {item.name} <Icon icon="eva:close-outline" onClick={() => removeLocation(item)}/>
                </div>
               )
             })}
             </div>
        <div className='preference-form-wrapper'>
           <div className="form-group">
                { <PlacesAutocomplete
                  value={address}
                  onChange={setAddress}
                  onSelect={handleSelect}
                >
                  {({getInputProps, suggestions, getSuggestionItemProps, loading}) => (
                    <div className="search-filed">
                      <Icon icon="carbon:search"/>
                      <input
                          {...getInputProps({
                            placeholder: 'Search Places ...',
                            className: 'location-search-input field',
                          })}
                        />
                        { suggestions && suggestions.length > 0 && <div  className="suggestion-list">
                          { loading ? <div className="suggestion-item">...loading</div> : null }
                          {suggestions.map(suggestion => {
                            return (
                              <div {...getSuggestionItemProps(suggestion)} className="suggestion-item">
                                {suggestion.description}
                              </div>
                            );
                          })}
                        </div>}
                    </div>
                  )}

                </PlacesAutocomplete>}
            </div>
            </div>
          <div className={Styles.formAction}>
            <Button variant='secondary' onClick ={(e: any) => {backButton(e)}}>Back</Button>
            <Button variant='primary' type="submit" onClick={handleSubmit(onSubmit)} disabled={false}>Complete Registration</Button>
            {notification && <NotificationAlert onClose={onClose} closable={true} > {message} </NotificationAlert> }
          </div>
   </form>
  )
}

export default CompanyDetails